import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { unregister } from './registerServiceWorker'

import store from './store'
import Router from './routes/Router'

import './polyfill'

// import { whyDidYouUpdate } from 'why-did-you-update'
// whyDidYouUpdate(React)

unregister()

ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.querySelector('#root')
)



// WEBPACK FOOTER //
// ./src/index.js